import { GtmTracker } from '@/modules/common/services/analytics';

const trackEvent = GtmTracker.trackerWithDefaultProps({
  page_screen: 'change_email',
  digital_experience: 'investor',
  experience_section: 'menu'
});

export function trackViewLoad() {
  trackEvent({
    event_type: 'load',
    event_name: 'view'
  });
}

export function trackSaveClick() {
  trackEvent({
    event_type: 'click',
    event_name: 'confirm',
    event_target: 'Trocar e-mail'
  });
}
